import React, { useState, useEffect, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin,
  Switch,
} from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { PlusCircleOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import {
  apiConfig,
  GetLabelForReportParameter,
  labelConfig,
  staticConfig,
} from "../reports.config";
import styles from "../../../assets/styles/styles";
import dayjs from "dayjs";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { TextArea } = Input;

const CreateCustomReport = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();
  const reportType = Form.useWatch("reportType", form);
  const [template, setTemplate] = useState([]);
  const [templateLoading, setTemplateLoading] = useState([]);
  const [paramterList, setParameterList] = useState([]);
  const [isAddressEnabled, setIsAddressEnabled] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerInfo: null,
    customerAddressInfo: null,
  });
  // const defaultValue = dayjs(activationDate);
  // disables future d

  // disable past Date and current
  // const disableDaysBeforeToday = (current) => {
  //   // Cannot select days before today
  //   return current && current.valueOf() < Date.now();
  // };

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Reports}/template`;
    let body = {
      session,
    };
    setTemplateLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setTemplateLoading(false);
      } else {
        const objList = res;
        setIsAddressEnabled(objList.isAddressEnabled);

        let allowedParameters = [];
        let allowedReportSubTypes = [];
        let allowedReportTypes = [];
        let reportCategories = [];

        objList?.allowedParameters?.forEach((element) => {
          allowedParameters.push({
            value: element.id,
            label: GetLabelForReportParameter(element.parameterName),
          });
        });

        objList?.allowedReportSubTypes?.forEach((element) => {
          allowedReportSubTypes.push({
            value: element,
            label: element,
          });
        });

        objList?.allowedReportTypes?.forEach((element) => {
          allowedReportTypes.push({
            value: element,
            label: element,
          });
        });

        objList?.reportCategories?.forEach((element) => {
          reportCategories.push({
            value: element?.id,
            label: element?.parameterName,
          });
        });
        setTemplate({
          allowedParameters,
          allowedReportSubTypes,
          allowedReportTypes,
          reportCategories,
        });

        setTemplateLoading(false);
      }
    });
  }

  console.log(template, "template");
  const onSubmit = (formValues) => {
    console.log(formValues);

    // return;
    formValues.reportParameters = paramterList.map((item) => ({
      parameterId: item.parameterId,
      reportParameterName: item.reportParameterName,
    }));
    const body = {
      ...formValues,
      // dateFormat: "dd MMMM yyyy",
      // locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Reports, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Report created successfully");

        // navigate("/detail-customer", {
        //   sta: { id: res.clientId, branchId: res.officeId },
        // });
        navigate("/custom-report-builder");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function handleDeleteParameter(item) {
    const updatedList = paramterList.filter((param) => param.parameterName !== item.parameterName);
    setParameterList(updatedList);
    BOM.AlertMsg(cnt.SUCCESS, "Parameter removed successfully");
  }
  function onCancel() {
    navigate("/custom-report-builder");
  }

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.newReport}
        pageItems={staticConfig.createCustomReportsBreadcrumbItems}
      />
      <Spin spinning={templateLoading || isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Row style={{}}>
            <Form
              initialValues={{
                active: false,
                isStaff: false,
                openCasa: false,
              }}
              form={form}
              layout="vertical"
              onFinish={onSubmit}
              name="customer-info"
              style={{ width: "100%" }}
            >
              <Row>
                <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.newReport}
                </Title>
              </Row>
              <Divider style={{ marginTop: 10, marginBottom: 30 }} />
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.reportDetails}
                  </Title>
                </Divider>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reportName}
                    name="reportName"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.reportName),
                      },
                    ]}
                  >
                    <Input
                      // className="of-bold-disable-input"
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.reportName)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reportCategory}
                    name="reportCategory"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.reportCategory),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(`${labelConfig.reportType}`, "select")}
                      options={template?.reportCategories}
                      showSearch
                    />
                    {/* <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.reportCategory)} /> */}
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reportType}
                    name="reportType"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.reportType),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(`${labelConfig.reportType}`, "select")}
                      options={template?.allowedReportTypes}
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={16} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.description}
                    name="description"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(labelConfig.description),
                    //   },
                    // ]}
                  >
                    <TextArea
                      style={{ minHeight: 100 }}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.description)}
                    />
                  </Form.Item>
                </Col>
                {reportType &&
                  reportType?.toLowerCase() !== "table" &&
                  reportType?.toLowerCase() !== "pentaho" && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.reportSubType}
                        name="reportSubType"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.reportSubType),
                          },
                        ]}
                      >
                        <Select
                          placeholder={BOM.handlePlaceholderMsg(
                            `${labelConfig.reportSubType}`,
                            "select"
                          )}
                          options={template?.allowedReportSubTypes}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}

                <Col
                  span={8}
                  style={{
                    padding: "0px 8px",
                    marginTop: 30,
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <Form.Item
                    name={"useReport"}
                    style={{ margin: 0, padding: 0 }}
                    valuePropName="checked"
                  >
                    <Switch className="custom-switch-2" />
                  </Form.Item>
                  <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>User Report UI</Text>
                </Col>
              </Row>

              {reportType && reportType?.toLowerCase() !== "pentaho" && (
                <>
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      {labelConfig.SQL}
                    </Title>
                  </Divider>
                  <Row>
                    <Col span={24} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={labelConfig.SQL}
                        name="reportSql"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(labelConfig.SQL),
                          },
                        ]}
                      >
                        <TextArea
                          style={{ minHeight: 100 }}
                          placeholder={BOM.handlePlaceholderMsg(labelConfig.SQL)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      {labelConfig.reportParameters}
                    </Title>
                  </Divider>

                  {BOM.HasPermission("READ_ADDRESS") && (
                    <AddParameterModal
                      formData={formData}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      paramterList={paramterList}
                      setParameterList={setParameterList}
                      template={template}
                    />
                  )}
                  {paramterList?.length > 0 && (
                    <List
                      // itemLayout="horizontal"
                      dataSource={paramterList}
                      grid={{ gutter: 16, column: 2 }}
                      renderItem={(item, index) => (
                        <List.Item
                          style={{
                            display: "flex",
                            margin: 0,
                            border: "1px solid #d9d9d9",
                            borderRadius: 10,
                            padding: 20,
                            marginBottom: 20,
                          }}
                          actions={[]}
                        >
                          {/* <Card> */}
                          <List.Item.Meta
                            description={item.reportParameterName ?? "----"}
                            title={
                              template?.allowedParameters.find(
                                (param, i) => param?.value === item?.parameterId
                              )?.label
                            }
                          />
                          <Button
                            type="primary"
                            danger
                            shape="round"
                            size="small"
                            onClick={() => handleDeleteParameter(item)}
                            icon={<DeleteOutlined />}
                            style={{
                              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                              // marginLeft: "auto",
                            }}
                          >
                            Remove
                          </Button>
                          {/* </Card> */}
                        </List.Item>
                        // <Card style={{ border: "1px solid red" }}></Card>
                      )}
                    />
                  )}
                </div>
              </Row>

              <Row>
                <Divider />
                {BOM.HasPermission("CREATE_CLIENT") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#92428B"
                    colorText="white"
                    hoverBackground="#AD4EA7"
                    isLoading={isLoading}
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form>
          </Row>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(CreateCustomReport);

const AddParameterModal = (props) => {
  const { template, isModalOpen, setIsModalOpen, paramterList, setParameterList } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSaveParameter = (formValues) => {
    const newParameter = {
      id: new Date().getMilliseconds(),
      reportParameterName: formValues.reportParameterName,
      parameterId: formValues.parameterId,
    };
    setParameterList([...paramterList, newParameter]);
    BOM.AlertMsg(cnt.SUCCESS, "Parameter added successfully");
    setIsModalOpen(false);
    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
        shape="round"
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Parameter Setup"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form form={useForm} layout="vertical" onFinish={handleSaveParameter} name="address-info">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.parameter}
                name={"parameterId"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.parameter),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.parameter, "select")}
                  options={template?.allowedParameters}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={`${labelConfig.parameterName} (Passed to Pentaho)`}
                name={"reportParameterName"}
                // rules={[
                //   {
                //     required: true,
                //     message: BOM.CheckReqFld(labelConfig.parameterName),
                //   },
                // ]}
              >
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.parameterName)} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};
